module.exports = __webpack_public_path__ + "img/abacusmachine.64b98032.svg";